(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colection-list-swiper"] && !Shopify.designMode) return;
  try {
    
    var collectionListSwiper = new Swiper('.theme-swiper', {
        slidesPerView: 1.3,
		spaceBetween: 30,
		slidesPerGroup: 1,
        loop: true,
        navigation: {
            nextEl: '.swipe-next-fls',
            prevEl: '.swipe-prev-fls',
        },
        autoHeight: false,
        pagination: {
            el: ".theme-swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + "</span>";
            }
        },
        breakpoints: {
          500: {
              slidesPerView: 2,
              slidesPerGroup: 2,
          },
          751: {
              slidesPerView: 3,
              slidesPerGroup: 3,
          },
          991: {
              slidesPerView: 4,
              slidesPerGroup: 4,
          },
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-swiper-video"] && !Shopify.designMode) return;
  try {
    
    var collectionSwiper = new Swiper('.video-swiper', {
        slidesPerView: 1.3,
		spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: '.video-next',
            prevEl: '.video-prev',
        },
        autoHeight: false,
        breakpoints: {
          500: {
              slidesPerView: 1,
          },
          751: {
              slidesPerView: 1,
          },
          991: {
              slidesPerView: 3,
          },
    }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-swiper"] && !Shopify.designMode) return;
  try {
    
    var collectionSwiper = new Swiper('.collection-swiper', {
        slidesPerView: 1.3,
		spaceBetween: 30,
		slidesPerGroup: 1,
        loop: true,
        navigation: {
            nextEl: '.swipe-next-col',
            prevEl: '.swipe-prev-col',
        },
        autoHeight: false,
        breakpoints: {
          500: {
              slidesPerView: 2,
              slidesPerGroup: 2,
          },
          751: {
              slidesPerView: 3,
              slidesPerGroup: 3,
          },
          991: {
              slidesPerView: 4,
              slidesPerGroup: 4,
          },
    }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["double-featured"] && !Shopify.designMode) return;
  try {
    
  //just add a .readless button for read less functionality
  $('.readmore-one').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full-one');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.product-description-short-one');
    descriptionShort.style.display = 'none';
  });
  $('.readless-one').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full-one');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.product-description-short-one');
    descriptionShort.style.display = 'block';
  });
    $('.readmore-two').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full-two');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.product-description-short-two');
    descriptionShort.style.display = 'none';
  });
  $('.readless-two').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full-two');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.product-description-short-two');
    descriptionShort.style.display = 'block';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-columns-swiper"] && !Shopify.designMode) return;
  try {
    
    var columnSwiper = new Swiper('.column-swiper', {
        slidesPerView: 1.3,
		spaceBetween: 30,
		slidesPerGroup: 1,
        loop: true,
        navigation: {
            nextEl: '.swipe-next-fcs',
            prevEl: '.swipe-prev-fcs',
        },
        autoHeight: false,
        breakpoints: {
          500: {
              slidesPerView: 2,
              slidesPerGroup: 2,
          },
          751: {
              slidesPerView: 3,
              slidesPerGroup: 3,
          },
    }
  });
  $('.readmore-column').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.column-description-full-one');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.column-description-short-one');
    descriptionShort.style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-swiper"] && !Shopify.designMode) return;
  try {
    
    var themeSwiper = new Swiper('.theme-swiper', {
        slidesPerView: 1.3,
		spaceBetween: 30,
		slidesPerGroup: 1,
        loop: true,
        navigation: {
            nextEl: '.swipe-next',
            prevEl: '.swipe-prev',
        },
        autoHeight: false,
        breakpoints: {
          500: {
              slidesPerView: 2,
              slidesPerGroup: 2,
          },
          751: {
              slidesPerView: 3,
              slidesPerGroup: 3,
          },
          991: {
              slidesPerView: 4,
              slidesPerGroup: 4,
          },
    }
    });

  } catch(e) { console.error(e); }
})();
})();
